module.exports = {
  authVkId: {
    method: 'POST',
    path: '/auth/vk_id',
    options: {
      noAuthToken: true,
    },
  },
  linkVkId: {
    method: 'POST',
    path: '/link/vk_id',
  },
  isLoggedIn: {
    method: 'POST',
    path: '/member/is-logged-in',
    // mock: (counter) => {
    //   return {
    //     isLogged: true,
    //     fullMemberAccess: counter > 2,
    //     viewCabinetMemberAccess: true,
    //   };
    // },
  },
  getProfile: {
    method: 'POST',
    path: '/member/profile',
    // mock: {
    //   id: 'e53894798db3252e1dc4fbba647f8d6e',
    //   email: 'user19275@example.com',
    //   country: null,
    //   firstname: 'John',
    //   lastname: 'Connor',
    //   zipcode: '354068',
    // },
  },
  register: {
    method: 'POST',
    path: '/member/register',
    options: {
      noAuthToken: true,
    },
  },
  resorePassword: {
    method: 'POST',
    path: '/member/panel/restore-password',
  },
  sendMessage: {
    method: 'POST',
    path: '/member/send-support-message',
  },
  sessionKeyConfirm: {
    method: 'POST',
    path: '/member/session-key-confirm',
    options: {
      noAuthToken: true,
    },
  },
  sessionKeyResend: {
    method: 'POST',
    path: '/member/session-key-resend',
    options: {
      noAuthToken: true,
    },
  },
  signIn: {
    method: 'POST',
    path: '/member/panel/sign-in',
    options: {
      noAuthToken: true,
    },
  },
  signup: {
    method: 'POST',
    path: '/member/signup',
    options: {
      noAuthToken: true,
    },
  },
};
